module.exports = __webpack_public_path__ + "img/keyboard-dark.a170f974.jpg";